export default "__VITE_PUBLIC_ASSET__00f56e1c__"